import { DateTime as u } from "luxon";
import { useState as m, useEffect as a } from "react";
import { ticketToService as p } from "../../../../../common/shared/serviceType.js";
import { useKioskLanding as f } from "../context.js";
import { useKioskMenus as g } from "./useKioskMenus.js";
function h(e, t, o) {
  for (let n = 0; n < t.length; n += 1) {
    const r = t[n];
    let i = !1;
    for (let s = 0; s < r.length; s += 1) {
      const c = r[s];
      if (!c.inDayRange(e))
        continue;
      if (i = !0, c.inFullRange(e, o))
        return {
          complies: !0,
          slot: c
        };
    }
    if (i)
      return {
        complies: !1
      };
  }
  return { complies: t.every((n) => n.length === 0) };
}
function l(e, t) {
  if (!e)
    return {
      complies: !0
    };
  const o = u.now();
  return h(
    o,
    [
      e.timetable.specialDays,
      e.timetable.specialHoursPerService,
      e.timetable.openingHours
    ],
    t.map(p)
  );
}
function R() {
  const { configuration: e } = f(), { services: t } = g(), [o, n] = m(
    l(e, t)
  ), r = () => {
    n(
      l(e, t)
    );
  };
  return a(() => {
    const i = setInterval(() => {
      r();
    }, 6e4);
    return () => {
      clearInterval(i);
    };
  }, [e, t]), {
    scheduleCompliance: o
  };
}
export {
  R as useKioskSchedule
};
//# sourceMappingURL=useKioskSchedule.js.map
